/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import PropTypes from "prop-types";
import { CURSOR_COLOR } from "../../Constants/constants";
import CursorCss from "./Cursor.css";

class Cursor extends Component {
  constructor(props) {
    super(props);
    this.imgHandle = null;
  }

  render() {
    const { xmin, xmax, ymin, ymax, angle } = this.props.cursorInfo;
    const cursorStyle = {
      top: ymin,
      left: xmin,
      height: ymax - ymin,
      width: xmax - xmin,
      backgroundColor: CURSOR_COLOR,
      transform: `rotate(${angle}deg)`
    };
    const { height, width } = cursorStyle;
    if (height > width) {
      cursorStyle.width = 1;
    } else {
      cursorStyle.height = 1;
    }
    // for making cursor visible on darker background we will use
    // inverted background image at cursor location as the cursor
    if (this.props.cursorImgUrl && this.imgHandle) {
      this.imgHandle.src = this.props.cursorImgUrl;
      this.imgHandle.style.display = "block";
      this.imgHandle.style.filter = "invert(1)";
      Object.assign(this.imgHandle.style, this.props.imgStyle);
      this.imgHandle.height = cursorStyle.height;
      this.imgHandle.width = cursorStyle.width;
    }

    return (
      <div
        className={`${CursorCss.cursor} ${
          this.props.isCursorVisible ? CursorCss.isVisible : null
        }`}
        style={cursorStyle}
        data-test-id="TextEditingCursor"
      >
        <img
          alt=""
          ref={handle => {
            this.imgHandle = handle;
          }}
        />
      </div>
    );
  }
}
export default Cursor;

Cursor.propTypes = {
  cursorInfo: PropTypes.objectOf(PropTypes.number).isRequired,
  cursorImgUrl: PropTypes.string.isRequired,
  isCursorVisible: PropTypes.bool.isRequired,
  imgStyle: PropTypes.objectOf(PropTypes.string)
};

Cursor.defaultProps = {
  imgStyle: {}
};
